module.exports = __webpack_public_path__ + "5f89905f9531decb2a23f019daa4a3fa.pdf";